<div class="header">
  <div class="title">Review Extracted Fields</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form>
  <ng-container *ngFor="let fieldDef of currentFields; let fieldIndex = index; let isLastField = last">
    <div class="flex flex-row">
      <div class="container__field-list__item__center w-full">
        <app-form-field
          [fieldDef]="fieldDef"
          [model]="model"
          [data]="data"
          [readonly]="false"
          [alwaysHideHistory]="true"
          (onUpdate)="onFieldUpdate($event)"
        ></app-form-field>
      </div>
      <div class="container__field-list__item__right flex">
        <button
          class="remove-email-field mt-6"
          type="button"
          mat-icon-button
          (click)="removeField(fieldIndex)"
          matTooltip="Remove"
        >
          <mat-icon [svgIcon]="'cancel'"></mat-icon>
        </button>
      </div>
    </div>
  </ng-container>
  <!-- Body -->

  <div class="actions justify-end">
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button tabindex="1" type="button" (click)="discard()">
        <span>Cancel</span>
      </button>

      <!-- Send -->
      <button class="send-button" mat-flat-button [color]="'primary'" type="submit" tabindex="0" (click)="save()">
        Save
      </button>
    </div>
  </div>
</form>
